import React from 'react'
import { Card } from '@rallyshift/design-system'
import { useOrganization } from '../contexts/OrganizationContext'

interface AuthShellProps {
  title: string
  subtitle?: string
  children: React.ReactNode
  /** Sits under the card: links to the other way in. */
  footer?: React.ReactNode
}

/**
 * The frame around every unauthenticated screen. The banner is the organisation's,
 * because a volunteer arriving from an email should recognise who is asking, not us.
 * RallyShift only signs the bottom.
 */
const AuthShell: React.FC<AuthShellProps> = ({ title, subtitle, children, footer }) => {
  const { organization } = useOrganization()

  return (
    <div className="min-h-screen bg-surface-page">
      <header
        className="flex items-center justify-center px-4 py-8"
        style={{ background: organization?.brand_color ?? 'var(--tenant-brand)' }}
      >
        {organization?.logo_url ? (
          <img src={organization.logo_url} alt={organization.name} className="h-14" />
        ) : (
          <span
            className="font-display text-display-md"
            style={{ color: organization?.on_brand_color ?? '#FFFFFF' }}
          >
            {organization?.name ?? 'RallyShift'}
          </span>
        )}
      </header>

      <main className="mx-auto w-full max-w-md px-4 py-8">
        <h1 className="font-display text-display-md text-text-primary">{title}</h1>
        {subtitle && <p className="mt-2 text-md text-text-secondary">{subtitle}</p>}

        <div className="mt-6">
          <Card>{children}</Card>
        </div>

        {footer && <div className="mt-6 text-center text-md">{footer}</div>}

        <p className="mt-8 text-center text-xs text-text-muted">
          mogelijk gemaakt door{' '}
          <span className="font-bold text-action-primary">RallyShift</span>
        </p>
      </main>
    </div>
  )
}

export default AuthShell
